import React, { useEffect, useState } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";

import { useLoading } from "../../../../shared/context/LoadingContext";

import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioMapaVenda from "./components/RelatorioMapaVenda";
import RelatorioFluxoCaixa from "./components/RelatorioFluxoCaixa";
import RelatorioDiarioAtendimento from "./components/RelatorioDiarioAtendimento";

import toast from "react-hot-toast";
import RelatorioDashboardFinanceiro from "./components/RelatorioDashboardFinanceiro";
import RelatorioContasPagarReceber from "./components/RelatorioContasPagarReceber";
import RelatorioFaturamento from "./components/RelatorioFaturamento";
import RelatorioInadimplencia from "./components/RelatorioInadiplencia";
import RelatorioExtratoCliente from "./components/RelatorioExtratoCliente/RelatorioExtratoCliente";

//Despesas
import RelatorioPesquisaDespesas from "./relatorioPesquisaDespesas/RelatorioPesquisaDespesas";
import "./RelatoriosFinanceiro.scss";

const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  // Relatório de um único dia, tirado diariamente → mostra só a Data Final,
  // que arranca em hoje.
  {
    value: "diarioAtendimento",
    label: "Diário de Atendimentos",
    apenasDataFinal: true,
  },
  { value: "mapaVenda", label: "Mapa de Venda" },
  // { value: "fluxo-caixa", label: "Relatório de Fluxo de Caixa" },
  // {
  //   value: "dashboard-financeiro",
  //   label: "Relatório de Dashboard Financeiro",
  // },
  // {
  //   value: "contas-pagar-receber",
  //   label: "Relatório de Contas a Pagar e Receber",
  // },
  // {
  //   value: "faturamento",
  //   label: "Relatório de Faturamento",
  // },
  { value: "inadimplencia", label: "Relatório de Inadimplência" },
  { value: "extratoCliente", label: "Relatório de Extrato de Cliente" },
  { value: "pesquisaDespesas", label: "Relatório de pesquisa de Despesas" },
  // {
  //   value: "categorias-despesas",
  //   label: "Relatório por Categorias de Despesas",
  // },
  // { value: "inadimplencia", label: "Relatório de Inadimplência" },
  // { value: "anual-financeiro", label: "Relatório Anual Financeiro" },
];

// Definição de quais relatórios suportam quais ações
const relatorioCaps = {
  diarioAtendimento: { gerar: true, exportar: true },
  mapaVenda: { gerar: true, exportar: false },
  "fluxo-caixa": { gerar: true, exportar: true },
  "contas-pagar-receber": { gerar: true, exportar: false },
  "dashboard-financeiro": { gerar: true, exportar: false },
  faturamento: { gerar: true, exportar: false },
  inadimplencia: { gerar: true, exportar: true },
  extratoCliente: { gerar: true, exportar: false },
  pesquisaDespesas: { gerar: true, exportar: false },
  // "categorias-despesas": { gerar: true, exportar: true },
  // inadimplencia: { gerar: false, exportar: true },
  // "anual-financeiro": { gerar: true, exportar: true },
};

function RelatoriosFinanceiro({ clinicaId, dadosMapa, auth, showExtrato }) {
  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();
  const [dadosClinica, setDadosClinica] = useState();
  // Unidades da clínica e a escolhida para o mapa de venda. Em clínicas de
  // unidade única a lista fica com 1 elemento e o seletor nem chega a aparecer.
  const [unidades, setUnidades] = useState([]);
  const [unidadeSelecionada, setUnidadeSelecionada] = useState("");
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    //Contador para forçar a atualização
    atualizacoes: 0,
  });

  useEffect(() => {
    const fetchDadosClinica = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setDadosClinica(responseData.clinica);

        // Só faz sentido oferecer a escolha quando a clínica tem mesmo mais do
        // que uma unidade — nas outras nem se pede a lista.
        if (responseData.clinica?.multiEstabelecimento) {
          const resUnidades = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/estabelecimentos/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          );
          setUnidades(resUnidades.estabelecimentos || []);
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchDadosClinica();
  }, [auth.perm, auth.token, clinicaId, sendRequest]);

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      toast.error("Por favor, selecione um tipo de relatório.");
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "gerar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      toast.error("Por favor, selecione um tipo de relatório.");
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "exportar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  // Função auxiliar para renderizar o componente de relatório correto
  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro: dataFiltro,
      dadosClinica: dadosClinica,
      auth: auth,
      acao: acao, // Passa a ação para o componente
      atualizacoes: atualizacoes,
      // Unidade escolhida (vazio = consolidado) e a lista, para o relatório
      // poder identificar no cabeçalho de que unidade é o mapa.
      unidadeSelecionada: unidadeSelecionada,
      unidades: unidades,
    };

    switch (open) {
      case "diarioAtendimento":
        return <RelatorioDiarioAtendimento {...props} />;
      case "mapaVenda":
        return <RelatorioMapaVenda {...props} dadosMapa={dadosMapa} />;
      case "fluxo-caixa":
        return <RelatorioFluxoCaixa {...props} />;
      case "dashboard-financeiro":
        return <RelatorioDashboardFinanceiro {...props} />;
      case "contas-pagar-receber":
        return <RelatorioContasPagarReceber {...props} />;
      case "faturamento":
        return <RelatorioFaturamento {...props} />;
      case "inadimplencia":
        return <RelatorioInadimplencia {...props} />;
      case "extratoCliente":
        return <RelatorioExtratoCliente {...props} showExtrato={showExtrato} />;
      case "pesquisaDespesas":
        return <RelatorioPesquisaDespesas {...props} />;
      // case "categorias-despesas":
      //   return <RelatorioCategoriasDespesas {...props} />;
      // case "inadimplencia":
      //   return <RelatorioInadimplencia {...props} />;
      // case "anual-financeiro":
      //   return <RelatorioAnualFinanceiro {...props} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps} // Passar as capacidades para potencialmente desabilitar botões
        // Manter o tipo de relatório selecionado
        relatorioSelecionado={dadosRelatorio.open}
        unidades={unidades}
        unidadeSelecionada={unidadeSelecionada}
        onUnidadeChange={setUnidadeSelecionada}
        relatoriosComUnidade={[
          "mapaVenda",
          "fluxo-caixa",
          "pesquisaDespesas",
          "diarioAtendimento",
          "inadimplencia",
        ]}
      />

      {renderizarRelatorio()}
    </div>
  );
}

export default RelatoriosFinanceiro;
